import $ from 'jquery';

$(document).ready(function() {
  const config = document.getElementById('request-approval-config');
  if (!config) return;

  const californiaStateId = config.dataset.californiaStateId;

  const showHideCaRequestPipelineDropdown = function() {
    if ($(`#licensee_state_${californiaStateId}`).is(":checked")) {
      $("#ca_request_pipeline_dropdown").show();
    } else {
      $("#ca_request_pipeline_dropdown").hide();
    }
  };

  $(`#licensee_state_${californiaStateId}`)
    .ready(showHideCaRequestPipelineDropdown)
    .change(showHideCaRequestPipelineDropdown);

  // On form submission remove the disabled attribute from the disabled checkboxes
  // so their value will be sent to the server.
  $("form").submit(function() {
    $('input[id^="licensee_state_"]').removeAttr("disabled");
  });
});
